import { ReactElement } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { ChoiceCard } from '../utils'
import { ChangeDecision } from './DecisionButtons'

interface Props {
  choice: ChoiceCard
  decision: ChangeDecision | undefined
  /** `true` for the approve option, `false` for the (default) deny option. */
  onDecide: (approved: boolean) => void
}

/** A question of the agent answered with one click, e.g. whether to import the basement. */
const ChoiceItem = ({ choice, decision, onDecide }: Props): ReactElement => {
  const approve = { approved: true, label: choice.approveLabel }
  const deny = { approved: false, label: choice.denyLabel }
  // The standard option first.
  const options = choice.defaultOption === 'approve' ? [approve, deny] : [deny, approve]
  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 1 }} data-cy="ai-chat-choice">
      <Typography variant="body2">{choice.question}</Typography>
      <Stack direction="row" spacing={1} mt={1} justifyContent="flex-end">
        {decision ? (
          <Typography variant="caption" color="text.secondary">
            {decision === 'approved' ? choice.approveLabel : choice.denyLabel}
          </Typography>
        ) : (
          options.map(({ approved, label }) => (
            <Button
              key={label}
              size="small"
              variant={approved === (choice.defaultOption === 'approve') ? 'contained' : 'outlined'}
              onClick={() => onDecide(approved)}
              data-cy={approved ? 'ai-chat-choice-approve' : 'ai-chat-choice-deny'}
            >
              {label}
            </Button>
          ))
        )}
      </Stack>
    </Box>
  )
}

export default ChoiceItem
